import React, { useEffect, InputHTMLAttributes } from "react";
import { useSetState } from "utils/functions.utils";
import { InputTypes } from "utils/interface.utils";
import "./input.ui.scss";

interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: any;
  iconPosition?: any;
  iconOnPress?: any;
  error?: any;
  label?: string;
  variant?: string;
  containerStyle?: any;
  inputStyle?: string;
  refElement?: any;
  placeholder?: string;
  isTextArea?: boolean
  onChange?:any
  fontSize?:string;
  backgroundColor?:string;
  fontFamily?:string;
  isProperties?:boolean;
  iconSize?:any;
  disabled?:boolean;
}

const Input = (props: IInputProps) => {
  // Redux

  const { backgroundColor,containerStyle, icon, iconPosition, iconOnPress, refElement, isTextArea, isProperties, iconSize, disabled, ...inputProps } = props;


  // State
  const [state, setState] = useSetState({ focus: false });

  //Hooks
  useEffect(() => {
  }, []);

  //Logic

  const getInputStyle = () => {
    if (props.variant === InputTypes.LINE) {
      return "input_container input_variant_line";
    }else if(props.variant === InputTypes.OTP){
      return "input_container input_variant_otp";
    }else if(props.variant === InputTypes.EDITOR){
      return "input_container input_variant_editor";
    }else if(isProperties){
      return "input_container input_variant_properties";
    }else if(props.variant === InputTypes.COLOR_PICKER){
      return "input_container input_variant_color_picker";
    }else {
      return "input_container";
    }
  };


  const getFocusStyle = () => {
    if (props.variant === InputTypes.LINE) {
      return "focus_variant_line";
    } else {
      return "focus";
    }
  };

  return (
    <div className={`input_wrapper ${isProperties ? "input_wrapper_properties" : ""}`} style={{...containerStyle}}>
      {props.label && <div className="input_label_wrapper">{props.label}</div>}
      <div className={state.focus ? `${getFocusStyle()} ${getInputStyle()}` : `${getInputStyle()}`} style={{backgroundColor:backgroundColor}}>
        {props.icon && props.iconPosition === "start" && (
          <div
            className="icon_wrapper"
          >
            {props.icon && <img src={props.icon} alt="image" className={"input_icon"} style={{width:iconSize.width,height:iconSize.height}}/>}
          </div>
        )}
        {props.isTextArea ?
          <textarea
            id={state.focus ? "set_bg" : "input_field"}
            ref={props.refElement}
            placeholder={props.placeholder}
            value={props.value as string}
            onFocus={() => setState({ focus: true })}
            onBlur={() => {
              setState({ focus: false });
            }}
            onChange={(e) => props.onChange(e)}
          /> :
          <input
            id={state.focus ? "set_bg" : "input_field"}
            style={{fontSize:props.fontSize,backgroundColor:backgroundColor,fontFamily:props.fontFamily}}
            onFocus={() => setState({ focus: true })}
            onBlur={() => {
              setState({ focus: false });
            }}
            ref={props.refElement}
            {...inputProps}
            disabled={disabled}
          />
        }
        {props.icon && props.iconPosition === "end" && (
          <div
            className="icon_wrapper"
            onClick={() => {
              props.iconOnPress();
            }}
          >
            {props.icon && <img src={props.icon} alt="image" className={"input_icon"} />}
          </div>
        )}
      </div>
      {/* {props.error && props.error.length > 0 && <div className="input_field_error">{props.error}</div>} */}
    </div>
  );
};

export default Input;
